import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import bookingSlice from "./bookingSlice";
import dataSlice from "./dataSlice";
import formDataSlice from "./formData";
import hotelSlice from "./hotelSlice";
import posSlice from "./posSlice";
import reportSlice from "./reportSlice";
import roomCategory from "./roomCategory";
import roomRateSlice from "./roomRateSlice";
import roomSlice from "./roomSlice";
import otaSlice from "./otaSlice";
import FilterSlice from "./FilterSlice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import ownerReportSlice from "./ownerReportSlice";
import attractionList from "./attractionData"; 
import miscellaneousChargesList from "./miscellaneousChargesSlice";
import operatingExpensesList from "./operatingExpensesSlice";
import recurringChargeList from "./recurringChargeSlice"
import calenderSlice from "./calenderSlice"
import reservationListSlice from "./reservationListSlice"
import dashboardListSlice from "./dashboardSlice"
import reservationViewSlice from "./reservationViewSlice"
import editReservationSlice from "./editReservationSlice"
import nightReportSlice from "./nightReportSlice"
import housekeepingSlice from "./housekeepingSlice"
import chatSlice from "./chatSlice"
import roomRateTabSlice from "./roomRateTabSlice"
import revenueGenerationSlice from "./revenueGenerationSlice"
import adminSlice from "./adminSlice"
import managementSlice from "./managementSlice"
import ownerdashboardSlice from "./ownerdashboardSlice"


const reducers = combineReducers({
  filters: FilterSlice,
  auth: authSlice,
  data: dataSlice,
  formData: formDataSlice,
  hotel: hotelSlice,
  roomCategory: roomCategory,
  room: roomSlice,
  roomRate: roomRateSlice,
  booking: bookingSlice,
  pos: posSlice,
  report: reportSlice,
  ota: otaSlice,
  ownerReport: ownerReportSlice,
  attractionList: attractionList,
  miscellaneousChargesList: miscellaneousChargesList,
  recurringChargeList: recurringChargeList,
  operatingExpensesList: operatingExpensesList,
  calender: calenderSlice,
  reservationList: reservationListSlice,
  dashboardList: dashboardListSlice,
  reservationView: reservationViewSlice,
  editReservation: editReservationSlice,
  nightReport: nightReportSlice,
  housekeeping: housekeepingSlice,
  chat: chatSlice,
  roomRateTab: roomRateTabSlice,
  revenueGeneration: revenueGenerationSlice,
  admin: adminSlice,
  management: managementSlice,
  ownerdashboard: ownerdashboardSlice
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ['filters']
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  // devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

// const reducers = combineReducers({
//   filters: persistReducer(filtersPersistConfig, FilterSlice),
//   auth: authSlice,
//   data: dataSlice,
//   formData: formDataSlice,
//   hotel: hotelSlice,
//   roomCategory: roomCategory,
//   room: roomSlice,
//   roomRate: roomRateSlice,
//   booking: bookingSlice,
//   pos: posSlice,
//   report: reportSlice,
//   ota: otaSlice,
// });

// const persistedReducer = persistReducer(rootPersistConfig, reducers);

// // const persistedReducer = persistReducer(persistConfig, reducers);

// const store = configureStore({
//   reducer: persistedReducer,
//   // devTools: process.env.NODE_ENV !== 'production',
//   middleware: [thunk],
// });

export default store;
